import { getPrivacyPolicyContent } from "api/rental-agreement/rental-agreement";
import { useData } from "data/data-provider";
import { globalJson } from "global/global_json";
import { useEffect, useState } from "react";

function PrivacyPolicy() {
  const [content, setContent] = useState([]); // Ensure content is always an array
  const [loading, setLoading] = useState(false);
  const { ourCompany } = useData();

  useEffect(() => {
    const getContent = async () => {
      setLoading(true);
      try {
        const response = await getPrivacyPolicyContent();

        // Ensure data is an array or default to an empty array
        setContent(response.data.privacy_policy);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching content", error);
      }
    };

    getContent();
  }, []);

  return (
    <div>
      <div className="mt-6 rounded-md  bg-bg-color p-4 min-h-[60vh]">
        {loading ? (
          <div className="flex justify-center items-center col-span-full min-h-[100vh]">
            <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 rounded-full border-t-transparent border-secondary-100"></div>
          </div>
        ) : (
          <div className="col-span-12 container">
            <div className="flex flex-col gap-y-4">
              {content?.length > 0 ? (
                content?.map((item: any, i: any) => (
                  <div className="rounded-md border border-muted" key={i}>
                    <div className="header rounded-md bg-[#3c3b3b] px-5 py-3">
                      <h4 className="text-lg">
                        {i + 1}. {item?.title}
                      </h4>
                    </div>
                    <div className="header border-t border-muted p-5 w-full">
                      <div className="grid grid-cols-1 gap-3 rounded-md w-full">
                        <div
                          className="prose prose-sm text-text-color break-words"
                          style={{ maxWidth: "100%" }}
                          dangerouslySetInnerHTML={{ __html: item?.content }}
                        />
                      </div>
                    </div>
                    {item?.content_picture &&
                      item?.content_picture !== "null" && (
                        <div className="header border-t border-muted p-5">
                          <div className="grid grid-cols-1 gap-3 rounded-md">
                            <img
                              alt="terms and conditions"
                              src={`https://fleet-management-images-upload-be.s3.amazonaws.com/${item?.content_picture}`}
                              height={660}
                              width={600}
                              className="w-full rounded-md"
                            />
                          </div>
                        </div>
                      )}
                  </div>
                ))
              ) : (
                <p>No content available.</p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default PrivacyPolicy;
